// extracted by mini-css-extract-plugin
export default {"desktop-mode":"zcOnIY","desktopMode":"zcOnIY","mobile-mode":"fG8Rz_","mobileMode":"fG8Rz_"};